import React from 'react';
import DegreeForm from '@components/degreeForm/DegreeForm';
import withDegree from '@hoc/withDegree';
import { useGetDegreeCoursesQuery, useGetCurrentUserQuery } from '@teachur/http-client';

interface EditDegreeProps {
  degree: Degree;
}

const EditDegree: React.FC<EditDegreeProps> = ({ degree }) => {
  const { data: user } = useGetCurrentUserQuery();
  const { data: courses = [], isLoading } = useGetDegreeCoursesQuery(degree.id);

  if (!user || !courses || isLoading) {
    return null;
  }

  return <DegreeForm degree={degree} courses={courses as any} />;
};

const ConnectedEditDegree = withDegree(EditDegree);

const Page = () => <ConnectedEditDegree />;

export default Page;
